export default __webpack_public_path__ + "static/media/Rangers.99bec410.svg";